import { __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
const play_background = (_a) => {
    var { size = 60 } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 60 60", fill: "currentColor", width: size, height: size }, props),
        React.createElement("path", { d: "M30,0c16.6,0,30,13.4,30,30S46.6,60,30,60C13.4,60,0,46.6,0,30S13.4,0,30,0z", fillRule: "evenodd", clipRule: "evenodd" })));
};
play_background.displayName = 'play_background';
play_background.propTypes = {
    size: PropTypes.number
};
export default play_background;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=play_background.js.map